import { ApiProvider } from 'providers/request'
import { StorageProvider } from 'providers/storage'
import { User } from 'models/user'
import {
  LoginData,
  LoginResponse,
  RequestPasswordParams,
  RecoverPasswordParams,
  SignupData,
} from 'models/auth'

export const AuthRepository = {
  login(dataInput: LoginData): Promise<LoginResponse> {
    return ApiProvider.post('/auth', dataInput).then((data) => {
      StorageProvider.set('token', data.access_token)
      StorageProvider.set('email', dataInput.email)
      return data
    })
  },
  logout(): Promise<void> {
    return ApiProvider.post('/auth/revoke').then(() => {
      StorageProvider.remove('token')
      window.location.assign("/login")
    })
  },
  requestPasswordRecovery(data: RequestPasswordParams): Promise<void> {
    return ApiProvider.post('/password/request', data)
  },
  recoverPassword(data: RecoverPasswordParams, uuid: string): Promise<LoginResponse> {
    return ApiProvider.post(`/password/recover/${uuid}`, data).then((data) => {
      StorageProvider.set('token', data.access_token)
      return data
    })
  },
  me(): Promise<User> {
    return ApiProvider.get('/me')
  },
  signup(data: SignupData): Promise<void> {
    return ApiProvider.post('/signup', data)
  },

  fetchInvitation(invitationId: string): Promise<User> {
    return ApiProvider.get(`/invitations/${invitationId}`)
  },

  completeInvitation(
    invitationId: string,
    email: string,
    data: Partial<SignupData>,
  ): Promise<void | LoginResponse> {
    return ApiProvider.post(`/invitations/${invitationId}`, data).then(() =>
      AuthRepository.login({ email: email, password: data.password! }),
    )
  },
}
